import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageGenerationStatus } from '@packages/global';

interface StatusBadgeProps {
  status: ImageGenerationStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation('generation');
  const getStatusStyles = (status: ImageGenerationStatus) => {
    switch (status) {
      case ImageGenerationStatus.COMPLETED:
        return 'bg-success/20 text-success border-success/30';
      case ImageGenerationStatus.PROCESSING:
        return 'bg-info/20 text-info border-info/30';
      case ImageGenerationStatus.FAILED:
        return 'bg-error/20 text-error border-error/30';
      case ImageGenerationStatus.SUBMITTED:
        return 'bg-warning/20 text-warning border-warning/30';
      default:
        return 'bg-bg-elevated text-gray-300 border-border-subtle';
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border backdrop-blur-sm ${getStatusStyles(status)}`}>
      {t(`status.${status}`)}
    </span>
  );
}